
import { 
  Home as HomeIcon,
  Droplets,
  PencilRuler,
  Sparkles,
  BugOff,
  Zap,
  Paintbrush,
  TreeDeciduous,
  Sprout,
  RefreshCcw,
  ThermometerSnowflake
} from "lucide-react";
import { serviceTypePhotos, fallbackImages } from "@/data/serviceTypePhotos";

const STANDARD_ASPECT_RATIO = 4/3;
const STANDARD_WIDTH = 800;

// Map service types to their corresponding Lucide icons
const serviceIcons: Record<string, any> = {
  'roofing': HomeIcon,
  'plumbing': Droplets,
  'general contracting': PencilRuler,
  'house cleaning': Sparkles,
  'pest control': BugOff,
  'electrical': Zap,
  'painting': Paintbrush,
  'tree service': TreeDeciduous,
  'landscaping': Sprout,
  'restoration': RefreshCcw,
  'hvac': ThermometerSnowflake
};

// Function to get the appropriate icon component for a service type
export const getServiceIcon = (serviceType: string) => {
  const normalizedType = serviceType.toLowerCase();
  return Object.entries(serviceIcons).find(([key]) => 
    normalizedType.includes(key)
  )?.[1] || HomeIcon;
};

export const getPlaceholderImage = (serviceType: string): string => {
  const service = serviceType.toLowerCase();
  const matchingService = Object.keys(serviceTypePhotos).find(key => 
    service.includes(key.toLowerCase())
  );
  
  if (matchingService) {
    return serviceTypePhotos[matchingService];
  }
  
  const fallbackKeys = Object.keys(fallbackImages);
  const index = service.length % fallbackKeys.length;
  return fallbackImages[fallbackKeys[index] as keyof typeof fallbackImages];
};

export const standardizeImageUrl = (url: string | null, serviceType: string): string => {
  if (!url) return getPlaceholderImage(serviceType);
  
  if (url.startsWith('/')) return url;
  
  if (url.includes('storage.googleapis.com')) {
    const width = STANDARD_WIDTH;
    const height = Math.round(width / STANDARD_ASPECT_RATIO);
    return `${url}?width=${width}&height=${height}&resize=contain`;
  }
  
  return url;
};
